import SortingV2 from './SortingV2';

export default SortingV2;
